export const processRawData = (rawData: string): string => {
  const rowDataStr = !rawData ? '' : rawData.replaceAll('_', ' ');
  const lowCaseDocStr = rowDataStr?.toLowerCase();
  return lowCaseDocStr?.[0]?.toUpperCase() + lowCaseDocStr?.substring(1);
};
